module.exports = __webpack_public_path__ + "img/forward.3287b652.svg";